import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

interface CourseCardProps {
  title: string;
  icon: string;
  link: string;
}

const CardContainer = styled(motion.div)`
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: 100%;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    
    &:before {
      opacity: 1;
    }
  }
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #00E5FF, #00A8E8, #00E5FF);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  @media (max-width: 576px) {
    padding: 20px 15px;
  }
`;

const CourseTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 25px;
  margin-top: 10px;
  color: #121E42;
  font-weight: 600;
  flex-grow: 1;
  text-shadow: 0 0 10px rgba(0, 229, 255, 0.3);
  position: relative;
  padding: 0 10px;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 2px;
    background-color: #00E5FF;
    box-shadow: 0 0 8px rgba(0, 229, 255, 0.8);
  }
  
  @media (max-width: 576px) {
    font-size: 1.1rem;
  }
`;

const CourseButton = styled.a`
  display: inline-flex;
  align-items: center;
  background-color: #00E5FF;
  color: #121E42;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #00C9E0;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 229, 255, 0.3);
    text-decoration: none;
    color: #121E42;
  }
  
  svg {
    margin-left: 8px;
  }
  
  @media (max-width: 576px) {
    width: 100%;
    justify-content: center;
  }
`;

const CourseCard: React.FC<CourseCardProps> = ({ title, link }) => {
  return (
    <CardContainer
      whileHover={{ y: -5 }}
      transition={{ duration: 0.3 }}
    >
      <CourseTitle>{title}</CourseTitle>
      <CourseButton href={link} target="_blank" rel="noopener noreferrer">
        Acessar ➝
      </CourseButton>
    </CardContainer>
  );
};

export default CourseCard;
